import Routes from './routes/routes'
import { ToastContainer } from 'react-toastify'
import 'react-tooltip/dist/react-tooltip.css'
import 'react-toastify/dist/ReactToastify.css'
import { ThemeProvider } from 'styled-components'
import { GlobalStyle } from './styles/global'
import { IconContext } from 'react-icons'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { api } from './services/api'
import React from 'react'
import { useConfigStore } from './store/config'
import { theme } from './styles/theme'
import Modal from 'react-modal'

const queryClient = new QueryClient()

function App() {
  const setConfig = useConfigStore.getState().setConfig
  const config = useConfigStore().config

  const [themeDefault, seThemeDefault] = React.useState(theme)

  const getConfig = async () => {
    const { data: response } = await api.get(`/config`)
    setConfig(response)
  }

  React.useEffect(() => {
    getConfig()
    // Configurar o elemento app para o react-modal
    Modal.setAppElement('#root')
  }, [])

  React.useEffect(() => {
    // Função auxiliar para evitar cores claras ilegíveis na marca
    const isLightOrInvalid = (hex?: string) => {
      if (!hex) return true
      const normalized = hex.trim().toLowerCase()
      return ['#e6e6e6', '#efefef', '#ffffff', '#f8fafc', '#f1f5f9', '#e2e8f0'].includes(normalized)
    }

    const safePrimary = (!isLightOrInvalid(config?.primaryColor) && config?.primaryColor) || '#2c30af'
    const safeSecondary = config?.secondaryColor || '#b8b8b8'

    seThemeDefault((prevTheme) => ({
      ...prevTheme,
      colors: {
        ...prevTheme.colors,
        primary: safePrimary,
        secondary: safeSecondary,
        text: '#1e293b',
        title: '#0f172a',
        label: '#334155',
        input: '#0f172a',
        placeholder: '#94a3b8',
        background: safeSecondary,
        surface: 'rgba(255, 255, 255, 0.5)',
        header: safePrimary,
        drawer: '#ffffff',
        border: '#cbd5e1',
      },
    }))
  }, [config])

  return (
    <>
      <ToastContainer />
      <QueryClientProvider client={queryClient}>
        <IconContext.Provider value={{ color: config?.primaryColor }}>
          <ThemeProvider theme={themeDefault}>
            <GlobalStyle />
            <Routes />
            
          </ThemeProvider>
        </IconContext.Provider>
      </QueryClientProvider>
    </>
  )
}

export default App
